
import { VenueRecommendation, DateRecommendation } from "./types";

interface EventLocationDateProps {
  status: string;
  flexibleLocationDescription?: string;
  event_venue_recommendations: VenueRecommendation[];
  event_date_recommendations: DateRecommendation[];
  date: Date | null;
}

export const getEventLocationAndDate = ({
  status,
  flexibleLocationDescription,
  event_venue_recommendations,
  event_date_recommendations,
  date
}: EventLocationDateProps) => {
  // Get the selected venue and date information
  const selectedVenueInfo = event_venue_recommendations.find(rec => rec.is_selected)?.venue;
  const selectedDateInfo = event_date_recommendations.find(rec => rec.is_selected)?.recommended_date;

  // Determine the location to display
  const displayLocation = selectedVenueInfo 
    ? `${selectedVenueInfo.name} - ${selectedVenueInfo.address}` 
    : flexibleLocationDescription || 'Location TBD';

  // Determine the date to display
  const displayDate = selectedDateInfo 
    ? selectedDateInfo 
    : date?.toISOString() || null;

  return {
    displayLocation,
    displayDate
  };
};
